// Initialization of the Vue singleton for both browser and test setups
import localforage from './localforage'
import plugins from './plugins'
import componentsWa from '../components-wa'

import '../icons'

export default (vueInstance) => {
  localforage(vueInstance)
  plugins(vueInstance)
  componentsWa(vueInstance)
}
